import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import { useFunctions, useStorage } from "reactfire";
import UserNotification from "../../../../../../../shared/components/Notification/UserNotification";
import FormValidator from "../../../../../../../shared/utils/FormValidator";
import { useHistory } from "react-router-dom";
import "./styles.scss";
import PageHeader from "../../../../../components/page-header/PageHeader";
import { DashboardPublicLibraryPages } from "../../PublicLibrary";
import BarLoader from "react-spinners/BarLoader";
import "./styles.scss";
import random from "randomstring";
import PublicContentCopyModal from "../../../components/publicContentCopyModal/PublicContentCopyModal";
import { HiOutlineClipboardCopy } from "react-icons/hi";
import { useAppUser } from "../../../../../../../contexts/user-context/UserContext";

interface Workshop {
  title: string;
  description: string;
  points: string;
  startDate: Date | null;
  endDate: Date | null;
  titleError: string;
  descriptionError: string;
  startDateError: string;
  endDateError: string;
  pointError: string;
  loading: boolean;
}

const initWorkshop: Workshop = {
  title: "",
  description: "",
  points: "",
  startDate: null,
  endDate: null,
  titleError: "",
  descriptionError: "",
  startDateError: "",
  endDateError: "",
  pointError: "",
  loading: false,
};

const PublicCreateWorkshop = () => {
  const creatRef = useFunctions().httpsCallable("savePublicWorkshop");
  const history = useHistory();
  const [showCopyDialog, setShowCopyDialog] = useState(false);
  const [workshop, setWorkshop] = useState(initWorkshop);
  const appUser = useAppUser();

  const [fileInput, setFileInput] = useState<any>(null);
  const [thumbnail, setThumbnail] = useState<{
    file: File | null;
    preview: any;
  }>({ file: null, preview: null });
  const storage = useStorage().ref();

  const create = () => {
    if (thumbnail.file) {
      setWorkshop({
        ...workshop,
        loading: true,
      });
      const uploadTask = storage
        .child(
          `publicworkshopthumbnails/${random.generate(
            10
          )}.${thumbnail?.file.name
            .split(".")
            .pop()
            ?.toLowerCase()}`
        )
        .put(thumbnail.file);
      uploadTask.on("state_changed", function(snapshot) {
        let progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log(progress);
      });
      uploadTask.then((snapshot) => {
        snapshot.ref.getDownloadURL().then((url) => {
          const reqBody = {
            title: workshop.title,
            description: workshop.description,
            startDate: workshop.startDate?.toDateString(),
            endDate: workshop.endDate?.toDateString(),
            points: parseInt(workshop.points) ? parseInt(workshop.points) : 0,
            thumbnail: url,
          };
          creatRef(reqBody)
            .then((res) => {
              if (res.data.data) {
                history.push(
                  "/dashboard/public/workshops/" + res.data.data + "/edit"
                );
              } else {
                UserNotification({
                  isSuccess: false,
                  message: "Workshop creation failed!",
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              UserNotification({
                isSuccess: false,
                message:
                  "Workshop creation failed!\nPlease check your connection.",
              });
            })
            .finally(() => {
              setWorkshop({
                ...workshop,
                loading: false,
              });
            });
        });
      });

      uploadTask.catch(() => {
        UserNotification({
          isSuccess: false,
          message: "Workshop creation failed!",
        });
        setWorkshop({
          ...workshop,
          loading: false,
        });
      });
    } else {
      setWorkshop({
        ...workshop,
        loading: true,
      });
      const reqBody = {
        title: workshop.title,
        description: workshop.description,
        startDate: workshop.startDate?.toDateString(),
        endDate: workshop.endDate?.toDateString(),
        points: parseInt(workshop.points) ? parseInt(workshop.points) : 0,
        thumbnail: "",
      };
      creatRef(reqBody)
        .then((res) => {
          if (res.data.data) {
            history.push(
              "/dashboard/public/workshops/" + res.data.data + "/edit"
            );
          } else {
            UserNotification({
              isSuccess: false,
              message: "Workshop creation failed!",
            });
          }
        })
        .catch((error) => {
          console.log("error", error, reqBody);
          UserNotification({
            isSuccess: false,
            message: "Workshop creation failed!\nPlease check your connection.",
          });
        })
        .finally(() => {
          setWorkshop({
            ...workshop,
            loading: false,
          });
        });
    }
  };

  const buttonSet = (
    <Row style={{ float: "right" }} className="p-2">
      <Col xs={6}>
        <div
          className="cancel-button blue"
          onClick={() => {
            !workshop.loading &&
              history.push(DashboardPublicLibraryPages.PUBLIC_WORKSHOPS);
          }}
        >
          Cancel
        </div>
      </Col>
      <Col xs={6}>
        <div
          className="save-button"
          onClick={() => {
            !workshop.loading && validateCreateCurriculumFormData() && create();
          }}
        >
          Save
        </div>
      </Col>
    </Row>
  );

  const validateCreateCurriculumFormData = (): boolean => {
    const wtValidation = FormValidator.validateString(
      workshop.title,
      "Workshop title",
      3,
      100
    );

    const sdValidation = FormValidator.validateWorkshopStartDate(
      workshop.startDate || undefined,
      "Start Date"
    );

    const pointValidation = parseInt(workshop.points)
      ? { message: "", isValid: true }
      : { message: "Please enter valid point", isValid: false };
    console.log("pointValidation", pointValidation);

    const edValidation =
      workshop.endDate === null
        ? { message: "Please set a valid End Date.", isValid: false }
        : workshop.endDate.toDateString() === new Date().toDateString() ||
          workshop.endDate <= new Date() ||
          workshop.endDate <=
            (workshop.startDate !== null ? workshop.startDate : new Date())
        ? { message: "Please set a valid End Date.", isValid: false }
        : { message: "", isValid: true };

    const wdValidation = FormValidator.validateString(
      workshop.description,
      "Workshop description",
      3,
      1000
    );

    setWorkshop({
      ...workshop,
      titleError: wtValidation.message,
      descriptionError: wdValidation.message,
      startDateError: sdValidation.message,
      endDateError: edValidation.message,
      pointError: pointValidation.message,
    });

    return (
      wtValidation.isValid &&
      wdValidation.isValid &&
      sdValidation.isValid &&
      pointValidation.isValid &&
      edValidation.isValid
    );
  };

  return (
    <>
      <PageHeader title="Create New Public Workshop" type="PUBLIC" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingBottom: "50px",
        }}
      >
        <>
          {appUser.userRole.isAdmin && (
            <Row>
              <Col xs={12}>
                <div
                  className="text-right"
                  style={{
                    color: "#959090",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  Copy content from{" "}
                  <span style={{ fontSize: "30px" }}>
                    <HiOutlineClipboardCopy
                      onClick={() => setShowCopyDialog(true)}
                      style={{
                        transform: "scaleX(-1)",
                        color: "#006699",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col
              xs={12}
              className="text-left font-weight-bold"
              style={{ color: "rgb(7, 66, 94)", width: "100%" }}
            >
              <label style={{ color: "#505050", fontWeight: "bold" }}>
                Workshop Title{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  workshop.titleError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                required={true}
                onChange={(e) => {
                  setWorkshop({
                    ...workshop,
                    title: e.target.value,
                    titleError: "",
                  });
                }}
                value={workshop.title}
              />
              <label className="error-message">{workshop.titleError}</label>
            </Col>
          </Row>
          <Row
            style={{
              marginBottom:
                workshop.startDateError.length < 1 &&
                workshop.endDateError.length < 1
                  ? "10px"
                  : "0px",
            }}
          >
            <Col xs={12} md={4}>
              <label
                style={{ color: "#505050", fontWeight: "bold" }}
                className="d-block"
              >
                Start Date{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <ReactDatePicker
                required={true}
                className={
                  workshop.startDateError.length < 1
                    ? "date-app-input calendar-img"
                    : "date-app-input calendar-img invalid"
                }
                dateFormat="dd/MM/yyyy"
                popperClassName="customDatePicker"
                selected={workshop.startDate && workshop.startDate}
                onChange={(date: Date) => {
                  setWorkshop({
                    ...workshop,
                    startDate: date,
                    startDateError: "",
                  });
                }}
                placeholderText={"DD/MM/YYYY"}
              />
              <label className="error-message d-block">
                {workshop.startDateError}
              </label>
            </Col>
            <Col xs={12} md={4}>
              <label
                style={{ color: "#505050", fontWeight: "bold" }}
                className="d-block"
              >
                End Date{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <ReactDatePicker
                required={true}
                className={
                  workshop.endDateError.length < 1
                    ? "date-app-input calendar-img"
                    : "date-app-input calendar-img invalid"
                }
                popperClassName="customDatePicker"
                selected={workshop.endDate && workshop.endDate}
                dateFormat="dd/MM/yyyy"
                onChange={(date: Date) => {
                  setWorkshop({
                    ...workshop,
                    endDate: date,
                    endDateError: "",
                  });
                }}
                placeholderText={"DD/MM/YYYY"}
              />
              <label className="error-message d-block">
                {workshop.endDateError}
              </label>
            </Col>
            <Col xs={12} md={4}>
              <label style={{ color: "#505050", fontWeight: "bold" }}>
                Points{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  workshop.pointError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                onKeyDown={() => {
                  setWorkshop({ ...workshop, pointError: "" });
                }}
                value={isNaN(Number(workshop.points)) ? "" : workshop.points}
                onChange={(e) => {
                  setWorkshop({
                    ...workshop,
                    points: isNaN(Number(e.target.value)) ? "" : e.target.value,
                  });
                }}
              />
              <label className="error-message d-block">
                {workshop.pointError}
              </label>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              className="text-left font-weight-bold"
              style={{ color: "rgb(7, 66, 94)", width: "100%" }}
            >
              <label style={{ color: "#505050", fontWeight: "bold" }}>
                Workshop Description{" "}
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <textarea
                style={{ minHeight: "200px" }}
                className={
                  workshop.descriptionError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                onChange={(e) => {
                  setWorkshop({
                    ...workshop,
                    description: e.target.value,
                    descriptionError: "",
                  });
                }}
                value={workshop.description}
              />
              <label className="error-message">
                {workshop.descriptionError}
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-flex">
              <div
                style={{
                  width: "200px",
                  flexShrink: 0,
                  alignItems: "center",
                }}
              >
                <label
                  className="m-0"
                  style={{ color: "#505050", fontWeight: "bold" }}
                >
                  Thumbnail
                </label>
                <div className="mt-3">
                  <button
                    className="app-button-small"
                    onClick={() => fileInput?.click()}
                  >
                    Select an image
                  </button>
                  <input
                    ref={(input) => setFileInput(input)}
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files) {
                        let reader = new FileReader();
                        let file = files[0];
                        reader.onloadend = () => {
                          setThumbnail({
                            preview: reader.result,
                            file: file,
                          });
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                </div>
              </div>

              <div className=" d-flex justify-content-start">
                <img
                  src={thumbnail.preview ? thumbnail.preview : ""}
                  alt=""
                  style={{ width: "200px" }}
                />
              </div>
            </Col>
          </Row>
          {workshop.loading && (
            <div className="my-3">
              <BarLoader
                height={4}
                width={"100%"}
                color={"#006699"}
                loading={workshop.loading}
              />
            </div>
          )}

          {buttonSet}
        </>
      </Container>
      <PublicContentCopyModal
        show={showCopyDialog}
        onHide={() => setShowCopyDialog(false)}
        activeList={{
          libraryHome: false,
          workshopContent: true,
        }}
      />
    </>
  );
};

export default PublicCreateWorkshop;
